/**
* Created by bieao on 2020/4/1.
*/
<template>
  <canvas id="bg" width="1868" height="940"></canvas>
</template>

<script>
export default {
  name: 'Background',
  mounted () {
    const bgCanvas = document.getElementById('bg').getContext('2d')
    const lineargradient = bgCanvas.createLinearGradient(0, 0, 600, 0)
    lineargradient.addColorStop(0, '#04172c')
    lineargradient.addColorStop(1, '#040b1a')
    bgCanvas.fillStyle = lineargradient
    bgCanvas.fillRect(0, 0, 1868, 940)
  }
}
</script>

<style scoped lang="scss">
  #bg {
    position: relative;
    z-index: -1;
    left:0;
    top:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Background.vue